var React = require('react');

function AlertInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 10v5m0 3v1m.894-16.211l9.382 18.764A1 1 0 0 1 21.382 23H2.618a1 1 0 0 1-.894-1.447l9.382-18.764a1 1 0 0 1 1.788 0z","fill":"none","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"}));
}

AlertInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = AlertInline;

AlertInline.default = AlertInline;
